import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { MessageCircle } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const MessageButton = () => {
  const [unreadCount, setUnreadCount] = useState(0);
  const { token, user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (token && user) {
      fetchUnreadCount();
      // iter_474 — Skip polling while tab hidden to save battery / cut
      // heat. Re-fire once on visibility return so badge isn't stale.
      const interval = setInterval(() => {
        if (document.hidden) return;
        fetchUnreadCount();
      }, 30000);
      const onVis = () => { if (document.visibilityState === 'visible') fetchUnreadCount(); };
      document.addEventListener('visibilitychange', onVis);
      return () => {
        clearInterval(interval);
        document.removeEventListener('visibilitychange', onVis);
      };
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps -- intentional: mount-only fetch / stable closure
  }, [token, user]);

  const fetchUnreadCount = async () => {
    try {
      const response = await axios.get(`${API}/messages/unread-count`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUnreadCount(response.data.unread_count || 0);
    } catch (error) {
      console.error('Failed to fetch unread messages:', error);
    }
  };

  if (!user) return null;

  return (
    <button
      onClick={() => navigate('/messages')}
      className="header-icon-glow relative p-2 rounded-lg transition-all"
      title="Messages"
      data-testid="messages-button"
      style={{
        '--header-icon-bg': '#A855F7',
        '--header-icon-bg-2': '#6c2bd9',
        '--header-icon-glow': 'rgba(168, 85, 247, 0.55)',
        '--header-icon-glow-2': 'rgba(168, 85, 247, 0.25)',
      }}
    >
      <MessageCircle size={20} />
      {unreadCount > 0 && (
        <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] bg-[#00CCFF] text-black text-xs font-bold rounded-full flex items-center justify-center px-1 ring-2 ring-[#0a0a0a]">
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </button>
  );
};
